import Container from '@/components/Container';
import React, { useEffect, useState } from 'react';
import { Api } from '@/services/Api';
import { SuperAdminUser } from '@/declarations/models/SuperAdminUser';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

export const AdminUsersList = () => {
  const [users, setUsers] = useState<SuperAdminUser[]>([]);

  useEffect(() => {
    const request = Api.getSuperAdminUsers();
    request.fetchDirect([]).then((fetched) => {
      if (Array.isArray(fetched)) {
        setUsers(fetched);
      } else if (fetched && 'users' in fetched) {
        setUsers(fetched.users);
      } else {
        setUsers([]);
      }
    });
    return () => request.abort();
  }, []);

  return (
    <Container left fullWidth p={2} top mt={0} column>
      <Container left fullWidth column>
        <Typography variant='h3' sx={{ fontSize: 30 }}>
          Superadmin-brukere
        </Typography>
        <Typography>
          For å bli superadmin i Museum24 må bruker gis global adminrolle til applikasjonen <i>Museum24 Admin 2</i> i
          Ekultur.
        </Typography>
      </Container>
      <Container left fullWidth pt={3} top mt={0} column sx={{ height: '80vh' }}>
        <TableContainer component={Paper}>
          <Table className='compact-table' stickyHeader sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Cura UUID</TableCell>
                <TableCell>Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.length > 0 ? (
                users.map((user) => (
                  <TableRow key={user.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell scope='row'>{user.id}</TableCell>
                    <TableCell>{user.cura_uuid}</TableCell>
                    <TableCell>{user.name}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align='center'>
                    No users found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </Container>
  );
};

export default AdminUsersList;
